import React from 'react';
import PropTypes from "prop-types";
import { Row, Col } from 'antd';
import { WrapLabel, LabelWrapper } from '../../style';
import { FormItem } from './style';
import { InputTextAreaField } from "../../../../../../CommonComponents/commonStyles";

export default function TextBoxComponent(props) {
  const { labelText, grantAgreementFlag } = props;
  return (
    <WrapLabel>
      <FormItem
        noMargin={grantAgreementFlag}
        colon={false}
        label={(
          <LabelWrapper>
            {labelText}
          </LabelWrapper>
        )}
      >
        <Row>
          <Col lg={24}>
            <InputTextAreaField
              name={props.name}
              aria-label={props.label}
              rows={4}
              maxLength={props.maxLength}
              onChange={props.inputChange}
              onBlur={props.onBlur}
              value={props.value}
            />
          </Col>
        </Row>
      </FormItem>
    </WrapLabel>
  );
}

TextBoxComponent.propTypes = {
  labelText: PropTypes.string.isRequired, 
  grantAgreementFlag: PropTypes.bool
};
